module.exports = __webpack_public_path__ + "static/media/geotechinfo.af09962b.webp";